import { createFileRoute } from '@tanstack/react-router';
import { useActiveRealmAPIContext } from '@interxfi/api-client';
import { PageLayout } from '@interxfi/app-components/components/layout/page-layout/page-layout';
import { RequiresAccess } from '@interxfi/design-system/access-context';
import { HorizontalStack } from '@interxfi/design-system/components/alignment/horizontal-stack';
import { Button } from '@interxfi/design-system/components/button';
import type { CustomTableHeaderProps } from '@interxfi/design-system/components/table/custom-header';
import PlusIcon from '@interxfi/design-system/icons/react/icon-plus';
import { PageTabRail } from '../../../../../../../../../../components/page-tab-rail/page-tab-rail';
import { type PortalTabbedNavigationTab, TabbedNavigationGroup } from '../../../../../../../../../../components/router/router-tabbed-navigation';
import { BanksimCreateInboundDrawer } from '../../../../../../../../../../features/banksim/inbound/banksim-create-inbound-drawer';
import { PaymentsWireTable } from '../../../../../../../../../../features/payments/wire/payments-wires-table';
import { getPageHead } from '../../../../../../../../../../util/routing/meta';
import { useRollupViewContext } from '../../../../../../../../../../util/view-context';

export const Route = createFileRoute('/_app/_clearing-core/_clearing-required/clearing/finance/_finance/payment/wire/_wire/')({
  staticData: {
    tab: {
      group: TabbedNavigationGroup.ClearingFinancePayments,
      label: 'Wires',
      order: 1,
    },
  } satisfies PortalTabbedNavigationTab<TabbedNavigationGroup.ClearingFinancePayments>,
  head: () => getPageHead('Wire Payments'),
  component: PaymentsWireList,
});

function TableHeader({ filter }: CustomTableHeaderProps) {
  const { activeRealmIsSimulated, activeTenantIsClearing } = useActiveRealmAPIContext();

  return (
    <PageTabRail
      actions={
        <HorizontalStack blockAlign="center" gap={2} wrap="nowrap">
          {activeTenantIsClearing && activeRealmIsSimulated ? (
            <RequiresAccess write>
              <BanksimCreateInboundDrawer
                trigger={<Button affixIcon={<PlusIcon aria-hidden />} aria-label="New Simulated Inbound Transfer" size="small" />}
              />
            </RequiresAccess>
          ) : null}

          {filter}
        </HorizontalStack>
      }
      group={TabbedNavigationGroup.ClearingFinancePayments}
    />
  );
}

function PaymentsWireList() {
  const viewContext = useRollupViewContext();

  return (
    <PageLayout>
      <PageLayout.Section noBorder>
        <PaymentsWireTable HeaderActions={TableHeader} view={viewContext} />
      </PageLayout.Section>
    </PageLayout>
  );
}
